import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'spe-vtonline',
    templateUrl: './vtonline.component.html',
    styleUrls: ['./vtonline.component.scss'],
    standalone: false
})
export class VtonlineComponent implements OnInit {
  private key?: string;
  private authKey?: string;
  private idCliente?: string;
  private subscriptions: Subscription[] = [];

  constructor(private activatedRoute: ActivatedRoute, private readonly routerService: Router) {}

  ngOnInit(): void {
    const queryParamsSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      this.key = params.KEY;
      this.key = this.key?.replaceAll(' ', '+');

      this.authKey = params.authKey;
      this.idCliente = params.ID_CLIENTE;
      if (this.authKey != undefined) {
        this.routerService.navigate([`/login`], {
          queryParams: { ID_CLIENTE: this.idCliente, authKey: this.authKey }
        });
      } else {
        this.routerService.navigate([`/login`], {
          queryParams: { KEY: this.key }
        });
      }
    });
    this.subscriptions.push(queryParamsSubscription);
  }
}
